import { Api } from './Api';
import { LoginFormProps, ResetPasswordFormProps, SignUpFormProps } from '../modules/auth/types';

export class Auth {
  static async signIn(params: LoginFormProps) {
    const requestData = {
      phone_number: params.phone,
      password: params.password,
    };
    return await Api.post('/auth/api/v1/login', requestData);
  }

  static async signUp(options: { data: SignUpFormProps }) {
    const values = options.data;
    const requestData = {
      phone_number: values.phone,
      name: values.firstName,
      surname: values.lastName,
      password: values.password,
      password_submit: values.confirmPassword,
      code: parseInt(values.confirmationCode, 10),
    };
    return await Api.post(`/auth/api/v1/register`, requestData);
  }

  static async sendCode(phone: string) {
    const { data } = await Api.post('/auth/api/v1/send-code', { phone_number: phone });
    return data.code;
  }

  static async getMe() {
    // TODO
    return await Api.get('/auth/api/v1/me');
  }

  static async resetPassword(params: ResetPasswordFormProps) {
    const formData = {
      phone_number: params.phoneNumber,
      code: params.code,
      password: params.password,
      password_submit: params.passwordSubmit,
    };
    return await Api.post('/auth/api/v1/restore-password', formData);
  }

  static async updatePassword(data: { old_password: string; password: string }) {
    return await Api.post('/auth/api/v1/update-password', data);
  }
}
